import { ref } from 'vue';
import { fetchApi } from '../utils/api';
import { API_BASE_URL, STORE_ID } from '../config';

const storeConfig = ref(null);

export const useStoreConfig = () => {
  const fetchStoreConfig = async () => {
    if (storeConfig.value) return storeConfig.value;
    try {
      const response = await fetchApi(`${API_BASE_URL}?action=getStore&id=${STORE_ID}`);
      const data = await response.json();
      if (data.success) {
        storeConfig.value = data.data;
      }
    } catch (error) {
      console.error('Error fetching store config:', error);
    }
    return storeConfig.value;
  };

  return {
    storeConfig,
    fetchStoreConfig,
  };
};
